module.exports = __webpack_public_path__ + "img/pic0.064a336f.webp";